<template>
    <div
        v-if="integration.data.length !== 0 && integration.type === 'GOOGLE'"
        class="grid w-full grid-cols-12"
    >
        <div
            :class="[deletable ? 'col-span-10' : ' col-span-12']"
            class="flex w-full items-center justify-between"
        >
            <img
                class="mr-3 h-10 w-10 rounded-full"
                :src="integration.data.profileImageUrl"
                alt="Profile Picture"
            />

            <div class="grow">
                <p class="text-sm font-medium text-iron-700">
                    {{ integration.data.name }}
                </p>
                <p class="text-xs text-iron-500">
                    {{ integration.data.email }}
                </p>
            </div>

            <div v-if="!deletable">
                <GoogleCalendar />
            </div>
        </div>
        <div
            v-if="deletable"
            class="col-span-2 flex items-center justify-end gap-2"
        >
            <Button
                variant="outline"
                size="sm"
                as="a"
                :href="route('app.integrations.google.edit')"
            >
                <RefreshCcw :size="16" />
            </Button>
            <Button variant="destructive" @click="removeIntegration" size="sm">
                <Trash :size="16" />
            </Button>
        </div>

        <div
            v-if="integration.errors"
            class="col-span-12 italic text-error-600"
        >
            <div
                v-if="
                    integration.errors.missing_calendar_scope ||
                    integration.errors.missing_calendar_events_scope
                "
            >
                Missing calendar scope please resync
            </div>
        </div>

        <div class="col-span-12"></div>
    </div>

    <div
        v-if="
            integration.data.length !== 0 &&
            integration.type === 'ICLOUD_CALENDAR'
        "
        class="grid grid-cols-12"
    >
        <div class="col-span-10 flex items-center">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 82 31"
                aria-hidden="true"
                class="apple-icloud-logo mr-5 h-12 w-12"
            >
                <path
                    d="M16.907 16.5h2.55V5.423h-2.55V16.5Zm1.28-12.832c.412 0 .763-.144 1.05-.43a1.41 1.41 0 0 0 .432-1.033c0-.407-.144-.753-.432-1.038a1.445 1.445 0 0 0-1.05-.426c-.407 0-.756.142-1.046.426-.291.285-.437.63-.437 1.038 0 .401.146.745.437 1.032.29.287.64.43 1.046.43v.001Zm9.915 13.156c1.14 0 2.157-.21 3.052-.631.864-.395 1.616-1 2.188-1.758.563-.752.908-1.624 1.037-2.619l.007-.091h-2.594l-.021.076a3.58 3.58 0 0 1-.713 1.465 3.35 3.35 0 0 1-1.258.943c-.5.219-1.065.328-1.695.328-.847 0-1.582-.22-2.204-.663-.623-.442-1.103-1.07-1.441-1.884-.338-.813-.507-1.776-.507-2.886v-.016c0-1.115.17-2.076.507-2.886.338-.81.817-1.434 1.439-1.875.62-.44 1.354-.66 2.199-.66.634 0 1.201.117 1.702.351.501.235.92.565 1.257.99.338.425.572.926.705 1.505l.026.105h2.59l-.004-.093c-.118-1.006-.46-1.895-1.028-2.668a5.886 5.886 0 0 0-2.204-1.819c-.901-.439-1.916-.658-3.044-.658-1.405 0-2.619.311-3.642.935-1.022.624-1.812 1.511-2.368 2.663-.556 1.152-.834 2.523-.834 4.113v.016c0 1.588.278 2.958.834 4.11.555 1.154 1.346 2.043 2.372 2.669 1.026.625 2.24.938 3.642.938Zm8.034-.324h2.55V1.24h-2.55V16.5Zm9.534.222c1.1 0 2.049-.231 2.846-.693.797-.461 1.413-1.122 1.846-1.982.434-.86.65-1.886.65-3.08v-.02c0-1.191-.218-2.216-.655-3.074a4.68 4.68 0 0 0-1.852-1.98c-.798-.46-1.744-.691-2.838-.691-1.086 0-2.03.23-2.829.694a4.69 4.69 0 0 0-1.855 1.981c-.438.859-.656 1.882-.656 3.07v.02c0 1.191.216 2.217.65 3.078.434.86 1.05 1.522 1.85 1.984.8.462 1.747.693 2.843.693Zm.004-2.066c-.572 0-1.063-.146-1.472-.436-.408-.291-.722-.711-.941-1.261-.219-.55-.329-1.213-.329-1.99v-.02c0-.776.11-1.438.33-1.985.22-.548.535-.967.944-1.259.408-.291.896-.437 1.461-.437.571 0 1.06.145 1.469.436.408.29.721.71.941 1.258.22.549.33 1.21.33 1.987v.02c0 .776-.11 1.438-.328 1.988-.218.55-.53.97-.936 1.262-.406.29-.896.437-1.469.437Zm10.596 2.066c.497.008.991-.071 1.46-.233.43-.156.798-.378 1.106-.668.309-.29.557-.639.73-1.026h.13V16.5h2.55V5.423h-2.55v6.444c0 .41-.055.782-.165 1.114a2.33 2.33 0 0 1-.485.853 2.153 2.153 0 0 1-.783.546 2.744 2.744 0 0 1-1.054.191c-.754 0-1.307-.216-1.657-.647-.35-.431-.526-1.063-.526-1.894V5.423h-2.55v7.166c0 .867.144 1.61.433 2.228.289.618.716 1.09 1.281 1.416.566.326 1.259.489 2.08.489Zm12.084-.024c.525 0 1.005-.08 1.441-.24a3.453 3.453 0 0 0 1.955-1.747h.13V16.5h2.55V1.24h-2.55v5.997h-.13a3.292 3.292 0 0 0-.802-1.073c-.338-.3-.727-.53-1.167-.694a4.093 4.093 0 0 0-1.433-.244c-.932 0-1.739.23-2.42.693-.681.463-1.207 1.122-1.579 1.978-.371.855-.557 1.873-.557 3.055v.016c0 1.175.186 2.19.559 3.049.372.858.9 1.52 1.585 1.984.684.464 1.49.697 2.418.697Zm.783-2.15c-.566 0-1.054-.145-1.466-.432-.412-.287-.728-.699-.95-1.235-.22-.536-.33-1.174-.33-1.913v-.016c0-.742.11-1.38.331-1.912.222-.533.539-.944.95-1.232.412-.288.9-.432 1.465-.432.56 0 1.046.146 1.46.436.413.29.735.703.964 1.237.228.534.343 1.169.343 1.906v.016c0 .732-.114 1.366-.34 1.902-.227.536-.548.95-.963 1.24-.415.29-.903.434-1.464.434v.001ZM8.856 3.158C9.35 2.56 9.7 1.745 9.7.92c0-.114-.01-.227-.03-.32-.805.03-1.774.536-2.351 1.217-.454.516-.877 1.341-.877 2.167 0 .123.02.247.031.288.052.01.134.021.217.021.721 0 1.629-.485 2.165-1.135h.001Zm.567 1.31c-1.207 0-2.186.733-2.815.733-.67 0-1.546-.691-2.598-.691C2.02 4.51 0 6.16 0 9.265c0 1.94.742 3.982 1.67 5.303.794 1.114 1.485 2.032 2.485 2.032.99 0 1.422-.66 2.65-.66 1.247 0 1.525.64 2.618.64 1.082 0 1.804-.991 2.484-1.971.763-1.124 1.083-2.218 1.093-2.27-.062-.02-2.134-.866-2.134-3.239 0-2.053 1.629-2.97 1.722-3.043-1.073-1.547-2.712-1.589-3.165-1.589Z"
                    style="fill: #1d1d1f; fill-rule: nonzero"
                    transform="translate(2.5 6.5)"
                ></path>
            </svg>

            <div>
                <p class="text-iron-900">
                    {{ integration.data.iCloudEmail }}
                </p>
            </div>
        </div>
        <div v-if="deletable" class="col-span-2 flex items-center justify-end">
            <a
                class="inline-flex rounded-md bg-yellow-400 px-3 py-2 text-iron-100 transition-all duration-75 hover:shadow-md"
                :href="route('app.integrations.google.edit')"
            >
                <svg
                    class="h-6 w-6"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
                        clip-rule="evenodd"
                    ></path>
                </svg>
            </a>
            <button
                class="ml-2 rounded-md bg-error-600 px-3 py-2 text-iron-100 hover:shadow-md"
                @click="removeIntegration"
            >
                <svg
                    class="h-6 w-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                    ></path>
                </svg>
            </button>
        </div>

        <div
            v-if="integration.errors"
            class="col-span-12 italic text-error-600"
        >
            <div
                v-if="
                    integration.errors.missing_calendar_scope ||
                    integration.errors.missing_calendar_events_scope
                "
            >
                Missing calendar scope please resync
            </div>
        </div>

        <div class="col-span-12"></div>
    </div>
</template>

<script setup lang="ts">
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import GoogleCalendar from "./logos/GoogleCalendar.svg";
import useConfirm from "../../ConfirmDialog/composables/useConfirm";
import { useI18n } from "vue-i18n";
import { RefreshCcw, Trash } from "lucide-vue-next";
import { Button } from "@/components/ui/button";

interface Props {
    integration: any;
    deletable: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    deletable: true,
});

const { show } = useConfirm();
const { t } = useI18n();

function capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

async function removeIntegration() {
    const ok = await show({
        header:
            t("integrations.delete.header") +
            ": " +
            capitalizeFirstLetter(props.integration.type.toLowerCase()),
        message: t("integrations.delete.message"),
        confirm: t("integrations.delete.confirm"),
        cancel: t("integrations.delete.cancel"),
    });

    if (ok) {
        await router.delete(`/integrations/google/${props.integration.id}`);
    }
}
</script>

<style></style>
